import Swal from "sweetalert2";

function SweetAlert(url, text, height) {
    return (
        Swal.fire({
            title: text,
            imageUrl: url,
            imageHeight: height,
            imageAlt: text,
        })
    )
}

export default SweetAlert;